/**
 * MqttInfo.js — Collapsible info panel showing MQTT broker details
 */

import React, { useState } from "react";

const INFO_ROWS = [
  { label: "Broker",    value: "broker.hivemq.com" },
  { label: "Port",      value: "8000 (WebSocket)" },
  { label: "URL",       value: "ws://broker.hivemq.com:8000/mqtt" },
  { label: "Topic",     value: "attendance/rfid" },
  { label: "Auth",      value: "None (public broker)" },
  { label: "Protocol",  value: "MQTTv3.1.1" },
];

export default function MqttInfo() {
  const [open, setOpen] = useState(false);

  return (
    <div className="glass-card overflow-hidden">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full px-6 py-4 flex items-center justify-between
                   hover:bg-slate-50/60 transition-colors"
      >
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-brand-50 flex items-center
                          justify-center text-brand-600">
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" strokeWidth="2.2">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07
                       19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67
                       A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361
                       1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0
                       0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339
                       1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
          </div>
          <span className="text-sm font-semibold text-slate-700">
            MQTT Broker Info
          </span>
        </div>
        <svg
          className={`w-4 h-4 text-slate-400 transition-transform duration-200 ${
            open ? "rotate-180" : ""
          }`}
          viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"
        >
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>

      {open && (
        <div className="px-6 pb-5 animate-fade-in">
          <div className="rounded-xl border border-slate-200 overflow-hidden">
            {INFO_ROWS.map((row, i) => (
              <div
                key={row.label}
                className={`flex items-center justify-between px-4 py-2.5 text-sm
                            ${i % 2 === 0 ? "bg-slate-50" : "bg-white"}`}
              >
                <span className="text-slate-500 font-medium text-xs uppercase tracking-wide">
                  {row.label}
                </span>
                <span className="font-mono text-xs text-slate-700 font-semibold">
                  {row.value}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
